// Mixins
import Vue from 'vue'
import Dossier from '../components/dossier/Dossier.vue'
import Fieldtype from '../components/fieldtypes/Fieldtype.js'
import AutoSlug from '../components/fieldtypes/AutoSlug.js'

window.Dossier = Dossier;
window.Fieldtype = Fieldtype;
window.AutoSlug = AutoSlug;



// WEBPACK FOOTER //
// ./app/statamic/resources/js/bootstrap/mixins.js